module.exports = __webpack_public_path__ + "img/zhenku1.cfd96d6b.png";